/**
 * Recursively flattens a nav tree of arbitrary depth into a single array.
 *
 * The app-bar back button and page-title lookup in `DashboardLayout` match against this
 * list by `path`. Nav items are nested to different depths (e.g. Email > Email Templates
 * is 2 levels under its group), so a flatten that only unrolls one or two hardcoded levels
 * silently drops deeper items — breaking breadcrumb/back-button navigation for their pages
 * without any visible error.
 */
export function flattenNavItems(items: any[]): any[] {
  const flat: any[] = [];
  const walk = (list: any[]) => {
    (list || []).forEach((item: any) => {
      flat.push(item);
      if (item?.children?.length) walk(item.children);
    });
  };
  walk(items);
  return flat;
}
